import {
  type HTMLAttributes,
  type PropsWithChildren,
  type ReactNode,
} from "react";
import { css } from "@emotion/react";
import { HeadingV2 } from "src/components/HeadingV2/HeadingV2.tsx";
import type { ExactTheme } from "src/lib/emotion/theme.ts";
import { motion, LazyMotion, domAnimation } from "framer-motion";

export const Collapse = ({
  children,
  collapsed,
  onCollapsedChange,
  icon,
  title,
  ...restProps
}: PropsWithChildren<
  {
    collapsed: boolean;
    icon: ReactNode;
    title: string;
    onCollapsedChange?: (collapsed: boolean) => void;
  } & HTMLAttributes<HTMLDivElement>
>) => {
  const initial = { height: collapsed ? 0 : "auto" };
  const animate = {
    transition: { type: "tween" },
    height: collapsed ? 0 : "auto",
  };
  const exit = { height: 0 };
  return (
    <div css={rootStyles} {...restProps}>
      <div
        css={headerStyles}
        onClick={() => {
          onCollapsedChange?.(!collapsed);
        }}
      >
        <div css={iconStyles}>{icon}</div>

        <HeadingV2 h={5}>{title}</HeadingV2>
      </div>
      <LazyMotion features={domAnimation}>
        <motion.div
          style={{ overflow: "hidden" }}
          initial={initial}
          animate={animate}
          exit={exit}
        >
          <div css={contentStyles}>{children}</div>
        </motion.div>
      </LazyMotion>
    </div>
  );
};
const iconStyles = (theme: ExactTheme) => css`
  color: ${theme.colorsV2.blue[500]};
  display: flex;
`;

const rootStyles = css`
  border-radius: 6px;
  box-shadow: 0 1px 5px 0 rgba(0, 0, 0, 0.15);
  :hover {
    box-shadow: 0 2px 15px 0 rgba(0, 0, 0, 0.15);
  }
`;

const contentStyles = () => css`
  padding: 0 15px 20px;
`;

const headerStyles = css`
  display: flex;
  position: sticky;
  background-color: white;
  z-index: 1;
  top: 0;
  border-radius: 6px;
  padding: 20px 15px;
  align-items: center;
  gap: 10px;
  cursor: pointer;
`;
